// @util/gearsync/api/useEbayPublish.ts
// Sends GearFocus listings to eBay (as drafts) via GearSync.

export type PublishResult = {
  id: string;
  status: 'queued' | 'error';
  error?: string;
};

/**
 * Queue the given GearFocus product IDs for publishing to eBay. The server
 * reads the products, enforces ownership + sellability, and forwards them to
 * GearSync. Returns a per-product result so the caller can report partial
 * failures.
 */
export async function publishToEbay(
  productIds: string[]
): Promise<PublishResult[]> {
  const res = await fetch('/api/gearsync/ebay/publish', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ productIds }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || 'Failed to send to eBay');
  }
  return Array.isArray(data?.results) ? data.results : [];
}
